import { useState } from "react";
import Inquiry from "./Inquiry";
import Orders from "./Orders";
import Quotation from "./Quotation";

function OrderDetail({ data, presetMessages, onPresetClick }) {
  const [activeTab, setActiveTab] = useState("Orders");

  return (
    <div className="container h-fit mx-auto  p-4 border shadow-lg">
      <div className="header flex justify-between items-center ">
        <h2 className="text-2xl font-bold text-[--color--1]">Product Details</h2>
      </div>
      <div className="tabs flex space-x-4 mt-2 border-b">
        <button
          onClick={() => setActiveTab("Negotiation")}
          className={`px-4 py-2 ${activeTab === "Negotiation"
            ? "border-b-2 border-green500 font-semibold"
            : "text-gray600"
            }`}
        >
          Negotiation
        </button>
        {/* <button
          onClick={() => setActiveTab("Quotation")}
          className={`px-4 py-2 ${activeTab === "Quotation"
            ? "border-b-2 border-green500 font-semibold"
            : "text-gray600"
            }`}
        >
          Quotation
        </button> */}
        <button
          onClick={() => setActiveTab("Orders")}
          className={`px-4 py-2 ${activeTab === "Orders"
            ? "border-b-2 border-green500 font-semibold"
            : "text-gray600"
            }`}
        >
          Orders
        </button>
      </div>
      <div className="">
        {activeTab === "Negotiation" && <Inquiry presetMessages={presetMessages} onPresetClick={onPresetClick} />}
        {/* {activeTab === "Quotation" && <Quotation />} */}
        {activeTab === "Orders" && <Orders data={data} />}
      </div>
    </div>
  );
}

export default OrderDetail;
